<template>
  <div class="singleview-container">
    <component
      :is="dynamicComponent"
      :source="source"
      :fields="doc.fields"
      :form="form"
      :updateField="updateField"
      :hideAlert="hideFormAlert"
      :relations="relations"
      :context="context"
      :headers="headers"
      :items="items"
      :hasPhoto="doc.hasPhoto"
      :onTabSelected="onTabSelected"
      :inPopup="true"
    />
  </div>
</template>

<script>
import DataForm from '@/components/form/DataForm'
import Detail from '@/components/single/Detail'
import Relations from '@/components/single/Relations'
import MapView from '@/components/list/MapView'

export default {
  components: {
    gform: DataForm,
    grelations: Relations,
    gcard: Detail,
    gmap: MapView,
  },
  props: {
    source: String,
    doc: Object, // actually doc.form
    headers: Array,
    form: Object,
    isLoading: Boolean,
    formErrors: Array,
    updateField: Function,
    hideFormAlert: Function,
    context: Object,
    singleViewType: String,
    onTabSelected: Function,
  },
  computed: {
    dynamicComponent () {
      switch (this.singleViewType) {
        case 'relation':
          return 'grelations'
        case 'edit':
          return 'gform'
        case 'map':
          return 'gmap'
        default:
          return 'gcard'
      }
    },
    relations () { return this.doc.relations },
    items () { return [this.form.data] },
  },
  created () {
    console.log(`SingleView: ${this.source} created`)
    // console.log('context', this.context)
  },
  destroyed () {
    console.log(`SingleView: ${this.source} destroyed`)
  },
}
</script>

<style scoped>
  .singleview-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>
